import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {requestUsers} from "../../../redux/Actions/users.action";
import {
  getUserPaginationUrls,
  getUsersList,
  getUserTotalCount,
} from "../../../redux/Selectors/users.selector";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";
import {userListURL} from "./userTable.constants";

export const useFetchUsers = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(requestUsers());
  };

  const refetch = () => {
    dispatch(requestUsers(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useUserTableData = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const {refetch, freshFetch} = useFetchUsers();
  const {setPageUrl} = usePageURLContext();
  const usersList = useSelector(getUsersList);
  const userTotalCount = useSelector(getUserTotalCount);
  const userUrls = useSelector(getUserPaginationUrls);

  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAfterDelete = () => {
    if (usersList.length === 1) {
      // If the last user on the current page is deleted, reset to the first page
      setCurrentPage(1);
      setPageUrl("");
      freshFetch();
    } else {
      refetch();
    }
  };

  const handlePageChange = (page) => {
    const url = currentPage < page ? userUrls?.nextUrl : userUrls?.prevUrl;
    dispatch(requestUsers(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      const searchUrl = generateQueryUrl(userListURL, tokens);
      dispatch(requestUsers(searchUrl));
      setPageUrl(searchUrl);
      setCurrentPage(1);
    } else {
      dispatch(requestUsers());
      setPageUrl("");
      setCurrentPage(1);
    }
  };

  return {fetchAfterDelete, handleSearch, paginationConfig, usersList, userTotalCount};
};
